/*
 * @Author: clive.cao
 * @Date: 2020-09-01 09:45:27
 * @LastEditTime: 2021-07-16 11:46:15
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /nvoicep-h5/src/directive/v-input-length.js
 */
/**
 * 定义vue指令
 */
import {getByteLen,getLength} from '../assets/lib/utils'
const error = require('@assets/img/ic_toast_alert@2x.png')
import { Toast } from 'vant';
export default {
  conUpdate:false,
  install(Vue) {
    //使用v-input-length ，
    Vue.directive('inputLength', {
      
      binding (el, binding, vnode) {
        console.log(el,binding,vnode)
      },
      inserted (el,binding) {
        el.addEventListener('keyup',function(){
          if(!this.conUpdate){
            if(this.value == '') return
            let trimValue = this.value.replace(/\s+/g,""); // 消除空格
            if(!this.attributes['data-block']) this.value = trimValue
            let length = getByteLen(trimValue) // 获取字符长度
            if(length > binding.value){ // 溢出判断
              Toast({
                  message: this.attributes['data-tips'].value,
                  icon: error,
              });
              this.value = getLength(trimValue,binding.value) // 截取有效字符
            }
            el.dispatchEvent(new Event('input')) // 派发事件
          }
        },false)
        el.addEventListener('paste',function(e){
         
          if(!this.conUpdate){
            setTimeout(() => {
              let _value = e.target.value //e.clipboardData.getData("text");
              if(_value == '') return
              let trimValue = _value.replace(/\s+/g,""); // 消除空格
              if(!this.attributes['data-block']) this.value = trimValue
              let length = getByteLen(trimValue) // 获取字符长度
              if(length > binding.value){ // 溢出判断
                Toast({
                    message: this.attributes['data-tips'].value,
                    icon: error,
                });
                this.value = getLength(trimValue,binding.value) // 截取有效字符
              }
              console.log(el,this.value)
              el.dispatchEvent(new Event('input')) // 派发事件
            }, 0);
            
          }
        },false)

        el.addEventListener('compositionupdate',function(){
          console.log('true')
          this.conUpdate = true
        })
        el.addEventListener('compositionend',function(){
          console.log('false')
          this.conUpdate = false
        },false)
      },
      update() {
        // console.log('update')
      },
      unbind (el,binding) {
        // document.documentElement.style.backgroundColor = ''
      },
    })
  }
}



// WEBPACK FOOTER //
// ./src/directive/v-input-length.js